export default "/presentation/resources/sap/ui/webcomponents/main/messagebundle_fi.6e6dd51450619a06.json"